module.exports = __webpack_public_path__ + "static/media/TRIDENT_CAROUSEL-5.87c183ba.jpg";